app.service("ProfileChangedModal", ["$uibModal", function ($uibModal) {
    return {
        show: function () {
            return $uibModal.open({
                animation: true,
                backdrop: 'static',
                templateUrl: _pb + 'employee/profile-changed-modal/profile-changed-modal.html',
                controller: ["$scope", "$uibModalInstance",
                    function ($scope) {
                        $scope.reload = function () {
                            window.location.reload();
                        };
                    }
                ],
            });
        }
    };
}]);
